import { type PayloadAction, createAction, createReducer } from '@reduxjs/toolkit';

import { emptyBillingData } from './billing.data';
import {
    mapBillingDataSubscription,
    mapReceivedGifts,
    mapReferralProgram,
    mapSentGifts,
    normalizeBillingPaidInfo,
} from './billingData.helpers';
import type {
    BillingDataState,
    GetBillingDataAction,
    GetBillingDataRequesSuccessAction,
    UpdateBillingDataAction,
} from './billingData.types';

const initialState: BillingDataState = {
    activeSubscriptionId: '',
    subscription: {},
    receivedGifts: {},
    sentGifts: {},
    referral: [],
    paidInfo: {
        trialExpires: 0,
        paidExpires: 0,
    },
    rawBillingData: emptyBillingData,
    isLoading: false,
    isLoaded: false,
    hasError: false,
};

export const getBillingDataRequestIfNotLoaded = createAction('billingData/getBillingDataRequestIfNotLoaded');
export const getBillingDataRequest = createAction<GetBillingDataAction>('billingData/getBillingDataRequest');
export const getBillingDataSuccess = createAction<GetBillingDataRequesSuccessAction>('billingData/getBillingDataSuccess');
export const billingDataFailure = createAction('billingData/billingDataFailure');
export const updateBillingDataRequest = createAction<UpdateBillingDataAction>('billingData/updateBillingDataRequest');
export const updateBillingDataSuccess = createAction<GetBillingDataRequesSuccessAction>('billingData/updateBillingDataSuccess');
export const setActiveSubscriptionId = createAction<string>('billingData/setActiveSubscriptionId');

const handleBillingDataSuccessAction = (
    state: any,
    { payload: { billingData } }: PayloadAction<GetBillingDataRequesSuccessAction>
): BillingDataState => ({
    ...state,
    subscription: mapBillingDataSubscription(billingData),
    paidInfo: normalizeBillingPaidInfo(billingData),
    receivedGifts: mapReceivedGifts(billingData),
    sentGifts: mapSentGifts(billingData),
    referral: mapReferralProgram(billingData),
    rawBillingData: billingData,
    isLoading: false,
    isLoaded: true,
    hasError: false,
});

export const billingDataReducer = createReducer(initialState, {
    [getBillingDataSuccess.type]: handleBillingDataSuccessAction,
    [updateBillingDataSuccess.type]: handleBillingDataSuccessAction,
    [setActiveSubscriptionId.type]: (state, action: PayloadAction<string>) => {
        state.activeSubscriptionId = action.payload;
    },
    [getBillingDataRequest.type]: (state) => {
        state.isLoading = true;
    },
    [updateBillingDataRequest.type]: (state) => {
        state.isLoading = true;
    },
    [billingDataFailure.type]: (state) => {
        state.isLoaded = true;
        state.isLoading = false;
        state.hasError = true;
    },
});
